import { render, staticRenderFns } from "./ComprehensiveQuerySumAll.vue?vue&type=template&id=1ed6584d&scoped=true&"
import script from "./ComprehensiveQuerySumAll.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveQuerySumAll.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensiveQuerySumAll.vue?vue&type=style&index=0&id=1ed6584d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6584d",
  null
  
)

export default component.exports